<template>
  <el-dialog title="导入预付数据预览" class="upload-excel-dialog" :visible.sync="centerDialogVisible" @close="closeDialog" width="70%" center>
    <el-table :data="data_list" stripe header-row-class-name="table-header-style" style="width: 100%">
      <el-table-column :label="date" v-for="(date, key) in header" :key='key' min-width="130">
        <template slot-scope="scope">
          {{data_list[scope.$index][key]}}
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <template>
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirmDialog">提交</el-button>
      </template>
    </span>
  </el-dialog>

</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    dialogPragram: Object,
    isShowPreview: Boolean
  },
  computed: {
    receiveData() {
      return this.dialogPragram;
    },
    centerDialogVisible() {
      return this.isShowPreview;
    },
    header() {
      return this.dialogPragram.tableData[0]
        ? Object.keys(this.dialogPragram.tableData[0])
        : [];
    },
    data_list() {
      var dataList = [];
      if (this.dialogPragram.tableData.length !== 0) {
        this.dialogPragram.tableData.forEach(element => {
          dataList.push(Object.values(element));
        });
      }

      return dataList;
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close", 0);
    },
    confirmDialog() {
      this.$emit("close", this.dialogPragram.tableData);
    }
  }
};
</script>
<style lang="scss">
// @import "../../../common/scss/color.scss";
.upload-excel-dialog {
   .el-dialog__header {
    background-color: #409eff;
    padding: 10px 20px 10px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    transform: translateY(-50%);
    .el-dialog__close {
      color: #fff;
    }
  }

  .el-dialog__body {
    padding: 20px 25px 0px;
    p {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/import-preview/preview-Prepaid-dialog.vue